<template>
<div v-if="data.length">
  <v-toolbar flat>
    <v-toolbar-title class="mt-n5">
      <span>{{`${data[8].title1} (ریال)`}}</span><br>
    </v-toolbar-title>
    <v-spacer />
    <h2 class="mt-n5 orange--text">{{data[8].price1 | currencyDisplay}}</h2>
  </v-toolbar>
  <div>
    <v-app-bar color="white" flat class="mt-n3">
      <span>{{`${data[2].title1} (${(data[2].percent).toFixed(2)}%)`}}</span>
      <v-spacer></v-spacer>
      <span>{{data[2].price1 | currencyDisplay}}</span>
    </v-app-bar>
    <v-app-bar color="white" flat class="mt-n6">
      <v-progress-linear color="success" :value="data[2].percent" height="10" />
    </v-app-bar>
  </div>
  <div>
    <v-app-bar color="white" flat class="mt-n6">
      <span>{{`${data[0].title1} (${(data[0].percent).toFixed(2)}%)`}}</span>
      <v-spacer></v-spacer>
      <span>{{data[0].price1 | currencyDisplay}}</span>
    </v-app-bar>
    <v-app-bar color="white" flat class="mt-n6">
      <v-progress-linear color="primary" :value="data[0].percent" height="10" />
    </v-app-bar>
  </div>
  <div>
    <v-app-bar color="white" flat class="mt-n6">
      <span>{{`${data[3].title1} (${(data[3].percent).toFixed(2)}%)`}}</span>
      <v-spacer></v-spacer>
      <span>{{data[3].price1 | currencyDisplay}}</span>
    </v-app-bar>
    <v-app-bar color="white" flat class="mt-n6">
      <v-progress-linear color="info" :value="data[3].percent" height="10" />
    </v-app-bar>
  </div>
  <div>
    <v-app-bar color="white" flat class="mt-n6">
      <span>{{`${data[1].title1} (${(data[1].percent).toFixed(2)}%)`}}</span>
      <v-spacer></v-spacer>
      <span>{{data[1].price1 | currencyDisplay}}</span>
    </v-app-bar>
    <v-app-bar color="white" flat class="mt-n6">
      <v-progress-linear color="warning" :value="data[1].percent" height="10" />
    </v-app-bar>
  </div>
  <div>
    <v-app-bar color="white" flat class="mt-n6">
      <span>{{`${data[5].title1} (${(data[5].percent).toFixed(2)}%)`}}</span>
      <v-spacer></v-spacer>
      <span>{{data[5].price1 | currencyDisplay}}</span>
    </v-app-bar>
    <v-app-bar color="white" flat class="mt-n6">
      <v-progress-linear color="error" :value="data[5].percent" height="10" />
    </v-app-bar>
  </div>
  <div>
    <v-app-bar color="white" flat class="mt-n6">
      <span>{{`اشخاص (${(data[6].percent).toFixed(2)}%)`}}</span>
      <v-spacer></v-spacer>
      <span>{{(data[6].price1 - data[7].price1) | currencyDisplay}}</span>
    </v-app-bar>
    <v-app-bar color="white" flat class="mt-n6">
      <v-progress-linear color="purple" :value="data[6].percent" height="10">
        <!-- <template v-slot:default="{ value }">
          <strong>{{ (value.toFixed(2)) }}%</strong>
        </template> -->
      </v-progress-linear>
    </v-app-bar>
  </div>
</div>
</template>

<script>
export default {
  name: 'BalancesProgress',
  data() {
    return {
      loading: true,
    }
  },
  props: ['data'],
}
</script>

<style lang="css" scoped>
</style>
